



























import { Vue, Component, Watch } from "vue-property-decorator";
import MoneyBlock from "@/components/home-page/MoneyBlock.vue";
import Request from "@/components/home-page/Request.vue";
import {
  LearningRequestShort as ILearningRequestShort,
  LearningRequestShortList as ILearningRequestShortList
} from "@/api/models";
import { getCurrentCompanyId, getCurrentEmployee } from "@/plugins/roles";
import learningRequests, {
  LearningRequestsListParams
} from "@/getinfo-api/learning-requests";
import { bookkeepingModule } from "@/plugins/modules-detect";

@Component({
  components: { MoneyBlock, Request }
})
export default class HomePageDocumentRequestManager extends Vue {
  showSpinner: boolean = false;
  requests: Array<ILearningRequestShort> = [];
  limit: number = 1000;
  requestCount!: number;

  data() {
    return {
      requestCount: undefined
    };
  }

  get isBookkeepingModule() {
    return bookkeepingModule();
  }

  @Watch("currentEmployee")
  upd() {
    this.searchOrdersByParams();
  }

  get date() {
    let date = new Date();
    return (
      date.getDate() +
      "." +
      (new Date().getMonth() + 1) +
      "." +
      new Date().getFullYear()
    );
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get learningRequestManager() {
    return this.currentEmployee?.roles.includes("learning_request_manager");
  }

  get documentManager() {
    return this.currentEmployee?.roles.includes("document_manager");
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  searchOrdersByParams(offset: number = 0) {
    this.showSpinner = true;
    this.requests = [];
    let params: LearningRequestsListParams = {
      companyId: this.selectedCompanyId,
      limit: this.limit,
      offset: offset,
      responsibleId: this.currentEmployee.id
    };

    learningRequests(params)
      .then((res: { data: ILearningRequestShortList }) => {
        this.requestCount = res.data.count;
        this.requests = this.requests.concat(res.data.requests);
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  @Watch("selectedCompanyId", { immediate: true })
  getOrder() {
    // this.searchOrdersByParams();

    setTimeout(() => {
      this.searchOrdersByParams();
    }, 1500);
  }
}
